import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/courses/CoursesAction";
import * as uiHelpers from "../CoursesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useCoursesUIContext } from "../CoursesUIContext";

export function CoursesTable({ 
  deleteCourses
}) {
  // Courses UI Context
  const coursesUIContext = useCoursesUIContext();
  const coursesUIProps = useMemo(() => {
    return {
      ids: coursesUIContext.ids,
      setIds: coursesUIContext.setIds,
      queryParams: coursesUIContext.queryParams,
      setQueryParams: coursesUIContext.setQueryParams,
      openEditCoursePage: coursesUIContext.openEditCoursePage
    };
  }, [coursesUIContext]);

  // Getting curret state of Courses list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.courses }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // Courses Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    coursesUIProps.setIds([]);
    dispatch(actions.getCourses(coursesUIProps.queryParams));
    return () => dispatch(actions.cleanCoursesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coursesUIProps.queryParams, dispatch]);

  // Belli Bir Dersin Alt Ders Listesi Sayfasını Açar
  const openSubCourseListPage = (parentId) => {
    const newQueryParams = { 
      filter: { parentId },
      sortOrder: "asc", // asc||desc
      sortField: "name",
      pageNumber: 1,
      pageSize: 10
    };
    coursesUIProps.setQueryParams(newQueryParams);
  }

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      parentId: coursesUIProps.queryParams.filter.parentId,
      isEditionAuthorized,
      isDeletionAuthorized,
      openSubCourseListPage,
      openEditCoursePage: coursesUIProps.openEditCoursePage,
      deleteCourses
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-9",
    style: {
      minWidth: "100px",
    }
  }

  if (!coursesUIProps.queryParams.filter.parentId || isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: coursesUIProps.queryParams.pageSize,
    page: coursesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                coursesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: coursesUIProps.ids,
                setIds: coursesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}